import React, { Component } from 'react';
import Loader from '../../Wizard/Loader';
import styled from 'styled-components';
import LinearProgress from '@material-ui/core/LinearProgress';
class LoadableComponent extends Component {
  constructor(props){
    super(props);
    this.state = {
      loading: true,
      loaded: null,
    };
    const {
      componentPromise,
    } = props;
    componentPromise.then((component) => this.handleComponentLoaded(component));
  }
  handleComponentLoaded(component){
    this.setState({
      loading: false,
      loaded: component,
    });
  }
  render() {

    const {
      loading,
      loaded,
    } = this.state;
    // console.log(Component);
    const {
      componentPromise,
      ...rest
    } = this.props;
    return loading 
      ? (
        <LoaderContainer>
          <TextBox>
            <LinearProgress color='primary' style={{width: '100%', marginTop: 8}} />
          </TextBox>
        </LoaderContainer>
      )
      : React.createElement(loaded, rest, null);
  }
}

const LoaderContainer = styled.div`
  position: relative;
  position: absolute;
  z-index: 2;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(0,0,0,.3);
`;

const TextBox = styled.div`
  display: flex;
  flex-direction: column;
  position:absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  max-width: 320px;
  justify-content: center;
  align-items: center;
  background: transparent;
  padding: 24px;
  border-radius: 3px;
  font-size: 1.5em;
  font-weight: bold;
`;

export default LoadableComponent;



// WEBPACK FOOTER //
// ./src/components/LoadableComponent/LoadableComponent.js